/* ==========================================================================
   Detect whether the current page is Arabic / RTL
   Purpose: Used by translation-related features so they only run on Arabic pages
========================================================================== */
function isArabicPage() {
  return (
    document.documentElement.lang?.startsWith("ar") ||
    document.documentElement.dir === "rtl" ||
    document.body?.dir === "rtl" ||
    document.body?.classList.contains("rtl") ||
    /^\/ar(\/|$)/.test(window.location.pathname)
  );
}


/* ==========================================================================
   PhotoSwipe zoom limiter
   Purpose: Captures PhotoSwipe v4 instances and overrides zoom behavior
   without modifying the theme gallery source
========================================================================== */
(function () {
  if (!window.PhotoSwipe || window.__pswpWrapped) return;
  window.__pswpWrapped = true;
  const Original = window.PhotoSwipe;

  window.PhotoSwipe = function (...args) {
    const instance = new Original(...args);
    // store globally
    window.__pswpInstance = instance;
    return instance;
  };
  window.PhotoSwipe.prototype = Original.prototype;
})();

document.addEventListener('click', function(e){
  if (!e.target.closest('.product-single__media-zoom')) return;
  setTimeout(() => {
    const pswp = window.__pswpInstance;
    if (!pswp) return;

    pswp.options.getDoubleTapZoom = function(isMouseClick, item){
      return item.initialZoomLevel * 1.7;
    };
  }, 0);
});


/* ==========================================================================
   Translate XB Wishlist texts into Arabic
   Purpose: Replaces wishlist plugin labels/messages on Arabic pages
========================================================================== */
function translateXbWishlist() {
  if (!isArabicPage()) return;

  const container = document.querySelector(".xb-wishlist-page");
  if (!container) return;

  const replacements = {
    "Share on": "شارك على",
    "Add to cart": "أضف إلى السلة",
    "Sold out": "نفد من المخزون",
    "Product name": "اسم المنتج",
    "Unit price": "سعر الوحدة",
    "Stock status": "حالة المخزون",
    "In stock": "متوفر",
    "Out of stock": "غير متوفر",
    "Empty wishlist": "قائمة الأمنيات فارغة",
    "Remove": "إزالة",
    "See something you like? Click the heart icon on any product to save it to your wishlist so you can find it easily later.":
      "هل رأيت شيئًا يعجبك؟ انقر على أيقونة القلب الموجودة على أي منتج لحفظه في قائمة أمنياتك حتى تتمكن من العثور عليه بسهولة لاحقًا."
  };

  container.querySelectorAll("*").forEach((el) => {
    if (!el.children.length) {
      const text = el.textContent.trim();
      if (replacements[text]) {
        el.textContent = replacements[text];
      }
    }

    if ("placeholder" in el && replacements[el.placeholder]) {
      el.placeholder = replacements[el.placeholder];
    }
  });
}

/* ==========================================================================
   Initialize wishlist translation and keep it updated on dynamic content changes
   Purpose: Handles AJAX/plugin DOM updates inside the wishlist page
========================================================================== */
let xbWishlistObserver = null;

function initXbWishlistTranslation() {
  if (!isArabicPage()) return;
  translateXbWishlist();

  const container = document.querySelector(".xb-wishlist-page");
  if (!container) return;

  if (xbWishlistObserver) {
    xbWishlistObserver.disconnect();
  }

  xbWishlistObserver = new MutationObserver(() => {
    translateXbWishlist();
  });

  xbWishlistObserver.observe(container, {
    childList: true,
    subtree: true
  });
}

/* ==========================================================================
   Create a custom language dropdown from the original Shopify select
   Purpose: Replaces the native language select UI with a custom styled dropdown
========================================================================== */
function initCustomLanguageDropdown(selectId) {
  const select = document.getElementById(selectId);
  if (!select || select.dataset.customized === "true") return;

  select.dataset.customized = "true";

  const wrapper = document.createElement("div");
  wrapper.className = "custom-lang-dropdown";

  const selected = document.createElement("button");
  selected.type = "button";
  selected.className = "custom-lang-selected";
  selected.setAttribute("aria-expanded", "false");
  selected.innerHTML = `
    <span class="custom-lang-selected__text">${select.options[select.selectedIndex]?.text || ""}</span>
    <span class="custom-lang-selected__icon">
      <svg width="8" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.25L5 5.25L9 1.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  const list = document.createElement("div");
  list.className = "custom-lang-options";

  Array.from(select.options).forEach((option, index) => {
    const item = document.createElement("button");
    item.type = "button";
    item.className = "custom-lang-option";
    item.textContent = option.text;

    if (option.selected) {
      item.classList.add("is-active");
    }

    item.addEventListener("click", () => {
      select.selectedIndex = index;
      select.dispatchEvent(new Event("change", { bubbles: true }));

      const selectedText = selected.querySelector(".custom-lang-selected__text");
      if (selectedText) {
        selectedText.textContent = option.text;
      }

      list.querySelectorAll(".custom-lang-option").forEach((btn) => {
        btn.classList.remove("is-active");
      });

      item.classList.add("is-active");
      wrapper.classList.remove("open");
      selected.setAttribute("aria-expanded", "false");
    });

    list.appendChild(item);
  });

  selected.addEventListener("click", (e) => {
    e.stopPropagation();
    const isOpen = wrapper.classList.toggle("open");
    selected.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });

  wrapper.appendChild(selected);
  wrapper.appendChild(list);
  select.parentNode.appendChild(wrapper);
}

/* ==========================================================================
   Initialize all custom language dropdowns
   Purpose: Supports both desktop and mobile localization selects
========================================================================== */
function initAllCustomLanguageDropdowns() {
  initCustomLanguageDropdown("thb-language-code-HeaderLocalization");
  initCustomLanguageDropdown("thb-language-code-HeaderLocalizationMobile");
}

/* ==========================================================================
   Close any open custom language dropdown when clicking outside
   Purpose: Prevents multiple dropdowns from staying open
========================================================================== */
function handleCustomDropdownOutsideClick(e) {
  document.querySelectorAll(".custom-lang-dropdown").forEach((wrapper) => {
    if (!wrapper.contains(e.target)) {
      wrapper.classList.remove("open");

      const trigger = wrapper.querySelector(".custom-lang-selected");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    }
  });
}

/* ==========================================================================
   Persist selected product size in localStorage and restore it later
   Purpose: Keeps the shopper's chosen size when navigating between product pages
========================================================================== */
(function () {
  const STORAGE_KEY = "oak_selected_size";

  const SIZE_VALUES = [
    "xs", "s", "m", "l", "xl", "xxl", "xxxl",
    "1 month", "3 months", "6 months", "9 months", "12 months", "18 months", "24 months",
    "s/m", "l/xl", "xxl/xxxl"
  ];

  const normalize = (value) => (value || "").trim().toLowerCase();

  const getItemValue = (item) =>
    (
      item?.getAttribute("orig-value") ||
      item?.querySelector(".swatch-button")?.getAttribute("data-value") ||
      item?.getAttribute("aria-label") ||
      ""
    ).trim();

  const isSizeItem = (item) => {
    const group = item?.closest(".swatch-view");
    if (!group) return false;

    return [...group.querySelectorAll(".swatch-button")].some((button) =>
      SIZE_VALUES.includes(normalize(button.dataset.value))
    );
  };

  const saveSelectedSize = () => {
    const item =
      document.querySelector('.swatch-view-item[aria-checked="true"]') ||
      document.querySelector(".swatch-button.swatch-selected")?.closest(".swatch-view-item");

    if (item && isSizeItem(item)) {
      localStorage.setItem(STORAGE_KEY, getItemValue(item));
    }
  };

  const applySelectedSize = () => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return false;

    const match = [...document.querySelectorAll(".swatch-view-item")]
      .filter(isSizeItem)
      .find((item) => normalize(getItemValue(item)) === normalize(saved));

    const button = match?.querySelector(".swatch-button");
    if (!button) return false;

    const alreadySelected =
      match.getAttribute("aria-checked") === "true" ||
      button.classList.contains("swatch-selected");

    if (!alreadySelected) {
      button.click();
    }

    return true;
  };

  const retryApplySelectedSize = () => {
    let tries = 0;
    const maxTries = 30;
    const delay = 300;

    const timer = setInterval(() => {
      tries += 1;

      if (applySelectedSize() || tries >= maxTries) {
        clearInterval(timer);
      }
    }, delay);
  };

  document.addEventListener("click", (e) => {
    const swatchItem = e.target.closest(".swatch-view-item");
    if (swatchItem && isSizeItem(swatchItem)) {
      localStorage.setItem(STORAGE_KEY, getItemValue(swatchItem));
    }

    if (e.target.closest('a[href*="/products/"]')) {
      saveSelectedSize();
    }
  });

  document.addEventListener("DOMContentLoaded", retryApplySelectedSize);
  document.addEventListener("shopify:section:load", retryApplySelectedSize);
  window.addEventListener("load", retryApplySelectedSize);
})();

/* ==========================================================================
   Global page initializers
   Purpose: Runs all shared initial setup once the DOM or Shopify sections load
========================================================================== */
function initThemeCustomizations() {
  initXbWishlistTranslation();
  initAllCustomLanguageDropdowns();
  translateElements();
}

document.addEventListener("DOMContentLoaded", initThemeCustomizations);
document.addEventListener("shopify:section:load", initThemeCustomizations);
document.addEventListener("click", handleCustomDropdownOutsideClick);


/* ==========================================================================
   Try On App Fix
   Powered By TEDMOB.com
========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".vto-app div[style*='text-align: center']");
  
  if (container) {
    container.style.marginTop = "40px";

    container.innerHTML = "Powered by ";
    const link = document.createElement("a");
    link.href = "https://tedmob.com";
    link.textContent = "TEDMOB.com";
    link.target = "_blank";
    link.style.color = "inherit";
    link.style.textDecoration = "underline";

    container.appendChild(link);
  }
});
/* ========================================================================== 
   Try On App Enhancements
   Powered By TEDMOB.com
========================================================================== */

function initTryOnFix() {
  const appGrid = document.querySelector("#lit-outfit .vto-outfit-builder > .vto-w-full.vto-grid");
  if (!appGrid) return false;

  const result = appGrid.children[0];
  const model = appGrid.children[1];
  const browse = appGrid.children[2];
  const outfit = appGrid.children[3];
  const addToCart = appGrid.children[4];

  /* ===== STEP LABELS ===== */
  const addStep = (el, text) => {
    if (!el || el.querySelector(".tedmob-step")) return;

    const label = document.createElement("div");
    label.className = "tedmob-step";
    label.innerText = text;
    el.prepend(label);
  };

  addStep(model, "Step 1: Select Model");
  addStep(browse, "Step 2: Browse Products (top and the bottom)");
  // addStep(outfit, "Add to Cart");

  /* ===== MODEL FILTER ===== */
  if (!model.querySelector(".tedmob-filter")) {
    const filter = document.createElement("div");
    filter.className = "tedmob-filter";
    filter.innerHTML = `
      <button type="button" data-type="all" class="active">All</button>
      <button type="button" data-type="women">Female</button>
      <button type="button" data-type="men">Male</button>
    `;

    model.querySelector(".vto-flex").after(filter);

    filter.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", function () {
        filter.querySelectorAll("button").forEach((b) => b.classList.remove("active"));
        this.classList.add("active");

        const type = this.dataset.type;
        const items = model.querySelectorAll(".vto-overflow-y-auto > div");

        items.forEach((item) => {
          const img = item.querySelector("img");
          const alt = (img?.getAttribute("alt") || "").toLowerCase();

          const isAddImageBox = !img;
          const isWomen = /\b(woman|women|girl)\b/.test(alt);
          const isMen = /\b(man|men|boy)\b/.test(alt);

          if (type === "all") {
            item.style.setProperty("display", "", "important");
          } else if (type === "women") {
            item.style.setProperty("display", isAddImageBox || isWomen ? "" : "none", "important");
          } else if (type === "men") {
            item.style.setProperty("display", isAddImageBox || isMen ? "" : "none", "important");
          }
        });
      });
    });
  }
  return true;
}

const observer = new MutationObserver(() => {
  if (initTryOnFix()) observer.disconnect();
  translateElements();
});

observer.observe(document.body, { childList: true, subtree: true });



//PREVIEW BUTTON REFRESH PAGE 

let previewButtonInterval = null;

function addPreviewTrueOnClick() {
  const buttonpreview = document.querySelector(
    "#lit-outfit .vto-outfit-builder > .vto-w-full.vto-grid > div:nth-child(1) .vto-text-center button"
  );

  //console.log("buttonPreview", buttonpreview);
  if (!buttonpreview) return;
  // Once the preview button exists, set preview to true
  localStorage.setItem("preview", "true");
  //console.log("Preview button found. preview = true");
  clearInterval(previewButtonInterval);
  previewButtonInterval = null;
  buttonpreview.addEventListener("click", function () {
   // console.log("PREVIEW CLICKED");
    localStorage.setItem("preview", "true");
  });
  //console.log("Preview listener added. Interval stopped.");
}
document.addEventListener("click", function (event) {
  const clickedImage = event.target.closest(
    "#lit-outfit .vto-outfit-builder > .vto-w-full.vto-grid > div:nth-child(2) img"
  );
  if (!clickedImage) return;
  if (localStorage.getItem("preview") === "true") {
    // console.log("IMAGE CLICKED WHILE PREVIEW TRUE");
    localStorage.setItem("preview", "false");
    window.location.reload();
  }
});

previewButtonInterval = setInterval(addPreviewTrueOnClick, 1000);






const translations = {
  // Colors
  "Starlit Black": "أسود كحيل",
  "Thunder Grey": "رمادي قاتم",
  "Thunder Gray": "رمادي قاتم",
  "Blue Sky": "أزرق سماوي",
  "Blue sky": "أزرق سماوي",
  "Creamy Dawn": "كريمي فاتح",
  "Sun Rays": "أصفر مشع",
  "Meadow Green": "أخضر فاتح",
  "Touch of Sand": "بيج رملي",
  "Blossom Pink": "زهر وردي",
  "Lavender Bud": "أرجواني خزامى",
  "Lavender bud": "أرجواني خزامى",
  "Nocturnal": "أزرق ليلي",
  "Cherry Blush": "أحمر كرزي",
  "Evergreen": "أخضر قاتم",
  "Cozy Cocoa": "بني كاكو",
  "Mocha Nest": "بني موكا",
  "Minty Dew": "أخضر مزرق",
  "Blushed Bloom": "برتقالي مزهر",
  "Ocean Blue": "أزرق بحري",

  // Form fields
  "Email address*": "البريد الإلكتروني",
  "Phone number*": "رقم الهاتف",
  "Auto Location": "الموقع التلقائي",

  // Currency names
  "US Dollar (USD)": "الدولار الأمريكي (USD)",
  "British Pound (GBP)": "الجنيه الإسترليني (GBP)",
  "United Arab Emirates Dirham (AED)": "الدرهم الإماراتي (AED)",
  "Saudi Riyal (SAR)": "الريال السعودي (SAR)",

  // Currency codes
  "USD": "دولار أمريكي",
  "GBP": "جنيه إسترليني",
  "AED": "درهم إماراتي",
  "SAR": "ريال سعودي"
};


function translateElements(root = document.body) {
    if (!isArabicPage()) return;
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node) {
        // skip empty/whitespace-only text nodes
        if (!node.nodeValue.trim()) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  let node;

  while ((node = walker.nextNode())) {
    const text = node.nodeValue.trim();

    if (translations[text]) {
      // preserve surrounding spaces if any
      node.nodeValue = node.nodeValue.replace(
        text,
        translations[text]
      );
    }
  }
}

observer.observe(document.body, {
  childList: true,
  subtree: true
});

  translateElements();

